import React from 'react';
import styled from 'styled-components';
import { EmptyState } from './shared';
import TurnBlock from './TurnBlock';

const Timeline = styled.div`
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-size: 0.875rem;
`;

export default function TraceTimeline({ turns }) {
  if (!turns || turns.length === 0) return <EmptyState>No trace events recorded for this conversation.</EmptyState>;

  return (
    <Timeline>
      {turns.map((turn) => (
        <TurnBlock key={turn.traceId} turn={turn} />
      ))}
    </Timeline>
  );
}
